
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CONTACTS

const preffix = "contacts";

export const useContact = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};